import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/esnext.json.parse.js";
import { formfileHandle } from "@/utils/utils";
export default {
  name: 'routetype',
  props: {
    form: {
      type: Object,
      default: {}
    },
    formlabel: {
      type: Object,
      default: {}
    },
    formoption: {
      type: Object,
      default: {}
    },
    formfield: {
      type: Object,
      default: {}
    },
    isadd: {
      type: Boolean,
      default: true
    },
    mapoptions: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      typeshow: false,
      dialogVisible: false,
      tableData: []
    };
  },
  watch: {
    isadd(val) {
      if (val) this.reset();
    },
    form(val) {
      if (Object.keys(val).length > 0) {
        val.children = val.json ? [...JSON.parse(val.json.replace(/(<\/?p.*?>)/gi, ''))] : [];
        val.isMultilevel = val.children.length > 0 ? true : false;
      }
    }
  },
  methods: {
    typeopen() {
      this.dialogVisible = true;
    },
    typeclose() {
      this.reset();
      this.dialogVisible = false;
    },
    reset() {
      if (this.$refs['formdata']) this.$refs['formdata'].resetFields();
    },
    /**
     * 选择地图
     */
    mapchange(val) {
      let obj = this.mapoptions.find(item => {
        return item.title === val;
      });
      this.form.mapbelong = obj.onlyid !== '' ? obj.title : '';
      this.form.mapbelongId = obj.onlyid !== '' ? obj.onlyid : '';
    },
    /**
     * 保存操作
     */
    savetypeHandle() {
      this.$refs['formdata'].validate(valid => {
        if (valid) this.$emit('submit', this.form);
      });
    }
  }
};